import AppStoreContext from 'contexts/AppStoreContext';
import React, { FC, useContext } from 'react';
import { useTranslator } from '@bluebeam/react-i18n';

const DefaultTopNavContent: FC = () => {
  const { state } = useContext(AppStoreContext);

  const selectedProject = state.projects.get(state.selectedProject);

  return (
    <div className="column justify-center mx4">
      {selectedProject && (
        <div className="bold font-size-6 color-gray-7">
          {selectedProject.name}
        </div>
      )}
    </div>
  );
};

export default DefaultTopNavContent;
